<template>
  <li
    class="flex flex-col gap-1"
    :class="{
      'ml-auto items-end': currentUserSender,
      'mr-auto items-start': !currentUserSender,
    }"
  >
    <span
      class="text-xs font-bold leading-4 text-black"
      :class="{
        'text-right': currentUserSender,
        'text-left': !currentUserSender,
      }"
    >
      {{ currentUserSender ? "Me" : name }}
    </span>
    <p
      class="min-w-[118px] bg-white px-3 py-2 text-left text-base leading-[22px] tracking-[-0.016em] text-black"
      :class="{
        'rounded-t-lg rounded-l-lg': currentUserSender,
        'rounded-t-lg rounded-r-lg': !currentUserSender,
      }"
    >
      {{ text }}
    </p>
    <div class="flex justify-between items-center flex-1 w-full">
      <span
        class="text-xs font-normal leading-4 text-black"
        :class="{
          'text-right order-1': currentUserSender,
          'text-left order-0': !currentUserSender,
        }"
        >{{ date }}</span
      >
      <div class="flex">
        <Icon icon="success" size="16" :color="read ? 'green' : 'gray'" />
        <Icon icon="success" size="16" :color="read ? 'green' : 'gray'" class="-ml-1.5" />
      </div>
    </div>
  </li>
</template>

<script setup>
import Icon from "../UI/Iconography/Icon/Icon.vue";

defineProps({
  name: String,
  text: String,
  date: String,
  currentUserSender: Boolean,
  read: Boolean,
});
</script>
